import React from 'react'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    const root = document.documentElement
    // Default to dark theme as per project preference
    root.classList.add('dark')
  }, [])
  return <>{children}</>
}

